module.exports = __webpack_public_path__ + "static/media/at_logo.7300b85c.jpg";